module.exports = __webpack_public_path__ + "static/media/pattern10.f2e0baeb.svg";